import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
import { validateNewOrderEmail } from "../../utils/emailUtils";
export class ManageOrder extends HttpForm {
    slug;
    data = false;
    constructor(params) {
        super();
        this.slug = params.slug;
    }
    mount() {
        return this.getOrder()
            .then((response) => {
            this.data = response.data.data;
            this.setLoadingState(true);
        })
            .catch(e => this.setError(e));
    }
    getOrder() {
        const url = '/api/order/' + this.slug;
        return axios.get(url).catch(e => this.setError(e));
    }
    processOrder() {
        if (this.data) {
            const url = '/api/order/' + this.data.reference + '/process';
            return axios.post(url).catch(e => this.setError(e));
        }
    }
    checkStatus() {
        if (this.data) {
            const url = '/api/order/' + this.data.reference + '/check';
            return axios.post(url).catch(e => this.setError(e));
        }
    }
    resendNotification() {
        if (this.data) {
            const url = '/api/order/' + this.data.reference + '/resend';
            return axios.post(url)
                .then((response) => {
                this.setSuccessMessage(response.data.message);
            }).catch(e => this.setError(e));
        }
    }
    updateOrderEmail(newEmail, confirmNewEmail) {
        if (!this.data) {
            return Promise.reject('Order data is not loaded');
        }
        const emailError = validateNewOrderEmail(newEmail, confirmNewEmail);
        if (emailError) {
            return Promise.reject(emailError);
        }
        const url = `/api/order/${this.data.reference}/email`;
        return axios.patch(url, { email: newEmail })
            .then((response) => {
            this.setSuccessMessage(response.data.message);
            return response.data;
        })
            .catch((e) => {
            this.setError(e);
        });
    }
}
